<template id="shoppingCart">
<section id="shopingCart">
  <div class="container" v-if="cart != null">
    <billInfo :res="res" :common_res="common_res" :shippinginfo="shippinginfo" :companyinfo="companyinfo" :invoice="{'curdate':curdate,'invoiceNo':invoiceNo}"></billInfo>
    <!------desktop version---->
    <div class="proTables hidden-xs">
      <div class="row">
        <div class="col-sm-12"> 
          <!---------->
          <div class="table-responsive">
            <table class="table table-hover" id="cartP">
              <thead>
                <tr>
                  <th scope="col" class="text-center">{{res.productid}}</th>
                  <th scope="col" class="text-center">{{res.product}}</th>
                  <th scope="col" class="text-center">{{res.pname}} <i style="cursor:pointer" v-on:click="dnProductsList" class="fa fa-download"></i></th>
                  <th scope="col" class="text-center">{{res.order}} <i style="cursor:pointer" v-on:click="deleteAllProducts" class="fa fa-trash"></i></th>
                  <th scope="col" class="text-center">{{res.qty}}</th>
                  <th scope="col" class="text-center">{{res.unitcost}}</th>
                  <th scope="col" class="text-center">{{res.discount}}</th>
                  <th scope="col" class="text-center">{{res.subtotal}}</th>
                </tr>
              </thead>
              <cartProduct :ocurr="curr" :fmt="fmt" :cartmode="cartmode" :readonly="false" :common_res="common_res" :res="res" :stock="getProductStock(product)" v-for="(product, pidx) in products" :iscart="true" :details="product" :idx="pidx" v-on:calSubtotal="setSubTotal($event, st)" :key="product.pdetails.product_id"/>
              <tbody class="nobordertop"> 
                <tr class="tiny" v-for="(ex) in cart.extras" v-if="ex.dprice != 0 && ex.itype == 'CD'" :key="ex">
                  <td></td>
                  <td></td>
                  <td colspan="5">
                    <span v-if="common_res['item_'+ex.id] != null">{{common_res['item_'+ex.id]}}</span>
                    <span v-else>{{getItemName(ex, cart.extralist)}}</span>
                    <br>
                    <span v-if="ex.ctype == 'PT' && ex.odprice && common_res['item_charge_'+ex.id]> 0" class="desc_txt">+{{(ex.odprice * 100) | format('#.0', common_res['item_charge_'+ex.id])}}</span>
                    <span v-else-if="ex.ctype == 'PT' && ex.odprice > 0" class="desc_txt">+{{(ex.odprice * 100) | format()}}% surcharge</span>
                    <span v-else-if="ex.ctype == 'AT' && ex.odprice > 0 && common_res['item_charge_'+ex.id]" class="desc_txt">+{{(ex.odprice) | format('#.0', common_res['item_charge_'+ex.id])}}</span>
                    <span v-else-if="ex.ctype == 'AT' && ex.odprice > 0" class="desc_txt">+{{(ex.odprice) | format()}} surcharge</span>
                    <span class="desc_txt"></span>
                  </td>
                  <td class="text-center">
                    <div class="subtotal"> {{curr}} <br>
                      <span v-if="ex.dprice >= 0" class="subTotal1"> {{ex.dprice | format()}} </span>
                      <span v-else class="subTotal1"> ({{(ex.dprice * -1) | format()}}) </span>
                    </div>
                  </td>
                </tr>
                <tr class="tiny" v-if="cart != null && cart.delivery_id != null && cart.delivery_cost != 0">
                  <td></td>
                  <td></td>
                  <td colspan="5">
                    <span v-if="common_res['item_'+chargedDelivery.id] != null">{{common_res['item_'+chargedDelivery.id]}}</span>
                    <span v-else>{{chargedDelivery.name}}</span>
                    <span v-if="chargedDelivery.conditions.vat != null" class="desc_txt"> ({{ common_res['order']['vat_include'] }})</span>
                    <br :cdid="chargedDelivery.id">
                    <span v-if="chargedDelivery.ctype == 'PT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0) && common_res['item_charge_'+chargedDelivery.id] != null" class="desc_txt">+{{((chargedDelivery.dprice + cart.delivery_extra) * 100) | format(null, common_res['item_charge_'+chargedDelivery.id])}}</span>
                    <!--
                    <span v-else-if="chargedDelivery.ctype == 'PT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0)" class="desc_txt">+{{((chargedDelivery.dprice + cart.delivery_extra) * 100) | format()}}% surcharge</span>
                    -->
                    <span v-else-if="chargedDelivery.ctype == 'AT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0) && common_res['item_charge_'+chargedDelivery.id] != null" class="desc_txt">+{{(chargedDelivery.dprice + cart.delivery_extra) | format(null, common_res['item_charge_'+chargedDelivery.id])}}</span>
                    <!--
                    <span v-else-if="chargedDelivery.ctype == 'AT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0)" class="desc_txt">+{{(chargedDelivery.dprice + cart.delivery_extra) | format()}} surcharge</span>
                    -->
                  </td>
                  <td class="text-center">
                    <div class="subtotal"> {{curr}} <br>
                      <span class="subTotal1"> {{cart.delivery_cost | format(fmt)}} </span>
                    </div>
                  </td>
                </tr>
                <tr class="tiny" v-if="cart != null && cart.payment_id != null && cart.payment_cost != 0">
                  <td></td>
                  <td></td>
                  <td colspan="5">
                    <span v-if="common_res['item_'+chargedPayment.id] != null">{{common_res['item_'+chargedPayment.id]}}</span>
                    <span v-else>{{chargedPayment.name}}</span>
                    <br>
                    <span v-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'PT' && common_res['item_charge_'+chargedPayment.id] != null" class="desc_txt">+{{((chargedPayment.dprice + cart.payment_extra) * 100) | format('#.0', common_res['item_charge_'+chargedPayment.id])}}</span>
                    <span v-else-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'PT'" class="desc_txt">+{{(chargedPayment.dprice * 100) | format()}}% surcharge</span>
                    <span v-else-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'AT' && common_res['item_charge_'+chargedPayment.id] != null" class="desc_txt">+{{(chargedPayment.dprice + cart.payment_extra) | format('#.0', common_res['item_charge_'+chargedPayment.id])}}</span>
                    <span v-else-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'AT'" class="desc_txt">+{{(chargedPayment.dprice) | format()}} surcharge</span>
                  </td>
                  <td class="text-center">
                    <div class="subtotal"> {{curr}} <br>
                      <span class="subTotal1"> {{cart.payment_cost | format(fmt)}} </span>
                    </div>
                  </td>
                </tr>
                <tr class="tiny" v-for="(ex) in cart.extras==null?[]:(cart.extras.filter(ex => ex.dprice != 0 && (ex.itype == 'OC' || ex.itype == 'SC')))" v-bind:key="ex.id">
                  <td></td>
                  <td></td>
                  <td colspan="5">
                    <span v-if="common_res['item_'+ex.id] != null">{{common_res['item_'+ex.id]}}</span>
                    <span v-else>{{getItemName(ex, cart.extralist)}}</span>
                    <br>
                    <span v-if="ex.ctype.indexOf(':') > 0 && ex.odprice > 0 && common_res['item_charge_'+ex.id] != null" class="desc_txt">{{getSurcharge(ex, cart.extralist, common_res['item_charge_'+ex.id])}}</span>
                    <span v-else-if="ex.ctype.indexOf(':') > 0 && ex.odprice > 0" class="desc_txt">{{getSurcharge(ex, cart.extralist)}} surcharge</span>
                    <span v-else class="desc_txt"></span>
                  </td>
                  <td class="text-center">
                    <div class="subtotal"> {{curr}} <br>
                      <span v-if="ex.dprice >= 0" class="subTotal1"> {{ex.dprice | format(fmt)}} </span>
                      <span v-else class="subTotal1"> ({{(ex.dprice * -1) | format(fmt)}}) </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td scope="row" class="text-center"><div class="productid"> </div></td>
                  <td class="text-center"></td>
                  <td class="text-center">
                    <div class="productname" v-for="(cdis, cidx) in cart.discountlist" v-if="cdis.cdprice < 0">{{cdis.cdprice}} {{ cdis }}</div>
                    <!--div class="productname" v-if="cart.payment_id != null">{{cart.payment_cost}}</div-->
                    <!--div class="productname" v-for="(ex, eidx) in cart.extras" v-if="ex.dprice != 0">{{ex.dprice}}</div-->
                  </td>
                  <td class="text-center"><div class="order"> </div></td>
                  <td class="text-center"><div class="qty"> </div></td>
                  <td class="text-center"><div class="unitcost"></div></td>
                  <td class="text-center"><div class="finaltotal"> {{res.total}}</div></td>
                  <td class="text-center"><div class="finalsubtotal"><nobr> {{curr}} 
                    <span class="subtotallast"> {{ftotal | format(fmt)}} </span>
                    <!--span v-if="ototal != null" class="subtotallast"> {{ototal | format()}} </span>
                    <span v-else class="subtotallast"> {{totala | format()}} </span-->
                  </nobr></div></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="protext">
            <p v-if="minAmt > 0"> * <span>{{res.firstorder | printLine({'curr':currencies[0].desp, 'firstamt':formatPrice(companyinfo.firstamount), 'day':getDays(companyinfo.hoursleft), 'hour':getHours(companyinfo.hoursleft)})}}</span> <span v-if="companyinfo.hoursleft > 0">{{res.firstorder_time | printLine({'curr':currencies[0].desp, 'firstamt':formatPrice(companyinfo.firstamount), 'day':getDays(companyinfo.hoursleft), 'hour':getHours(companyinfo.hoursleft)})}}</span></p>
            <!--
            <p v-if="drange.amount != -1"> * {{res.freeshipping | printLine({'shipping':res.sfexpress, 'curr':curr, 'drange':formatPrice(drange.amount), 'displayname':drange.displayname})}}</p>
            -->
          </div>
          <!--------> 
        </div>
      </div>
    </div>
    <!------mobile version---->
    <div class="mobilepro visible-xs">
      <div class="row"> 
        <!-------->
        <div class="col-sm-12">
          <div class="mobileproduct" id="mCartP">
            <div class="formHeadings"> <span><img src="@/images/valueicon.png" alt="#"></span>Product</div>
            <mCartProduct :stock="getProductStock(product)" :cartmode="cartmode" :readonly="false" v-for="(product, pidx) in products" :common_res="common_res" :res="res" :details="product" :iscart="true" :idx="pidx" v-on:calSubtotal="setSubTotal($event, st)" :key="product.pdetails.product_id"/>
            <div class="pull-right label" v-for="(cdis, cidx) in cart.discountlist" v-if="cdis.cdprice < 0">{{cdis.cdprice}}</div>
            <div class="mobcharge" v-for="(ex, eidx) in cart.extras" v-if="ex.dprice != 0 && ex.itype == 'CD'">
              <div class="mobdiscount1">
                <div class="pull-left">
                  <div class="mobileunitcost1">
                    <span v-if="common_res['item_'+ex.id] != null">{{common_res['item_'+ex.id]}}</span>
                    <span v-else>{{getItemName(ex, cart.extralist)}}</span>
                    <br>
                    <span v-if="ex.ctype == 'PT' && ex.odprice > 0 && common_res['item_charge_'+ex.id] != null" class="desc_txt">+{{(ex.odprice * 100) | format('#.0', common_res['item_charge_'+ex.id])}}</span>
                    <span v-else-if="ex.ctype == 'PT' && ex.odprice > 0" class="desc_txt">+{{(ex.odprice * 100) | format()}}% surcharge</span>
                    <span v-else-if="ex.ctype == 'AT' && ex.odprice > 0 && common_res['item_charge_'+ex.id] != null" class="desc_txt">+{{(ex.odprice) | format('#.0', common_res['item_charge_'+ex.id])}}</span>
                    <span v-else-if="ex.ctype == 'AT' && ex.odprice > 0" class="desc_txt">+{{(ex.odprice) | format()}} surcharge</span>
                    <span class="desc_txt"></span>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="mobileunitcost"></div>
                  <div v-if="ex.dprice >= 0" class="mobileunithkdvalue"> {{curr}} {{ex.dprice |format()}} </div>
                  <div v-else class="mobileunithkdvalue"> {{curr}} ({{(ex.dprice * -1) |format()}}) </div>
                </div>
              </div>
            </div>
            <div class="mobcharge" v-if="cart.delivery_id != null && cart.delivery_cost != 0">
              <div class="mobdiscount1">
                <div class="pull-left">
                  <div class="mobileunitcost1" :c="chargedDelivery.conditions">
                    <span v-if="common_res['item_'+chargedDelivery.id] != null">{{common_res['item_'+chargedDelivery.id]}}</span>
                    <span v-else>{{chargedDelivery.name}}</span>
                    <br>
                    <span v-if="chargedDelivery.conditions.vat != null" class="desc_txt">{{ common_res['order']['vat_include'] }}</span>
                    <br>
                    <span v-if="chargedDelivery.ctype == 'PT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0) && common_res['item_charge_'+chargedDelivery.id] != null" class="desc_txt">+{{((chargedDelivery.dprice + cart.delivery_extra) * 100) | format('#.0', common_res['item_charge_'+chargedDelivery.id])}}</span>
                    <span v-else-if="chargedDelivery.ctype == 'PT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0)" class="desc_txt">+{{((chargedDelivery.dprice + cart.delivery_extra) * 100) | format()}}% surcharge</span>
                    <span v-else-if="chargedDelivery.ctype == 'AT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0) && common_res['item_charge_'+chargedDelivery.id] != null" class="desc_txt">+{{(chargedDelivery.dprice + cart.delivery_extra) | format('#.0', common_res['item_charge_'+chargedDelivery.id])}}</span>
                    <span v-else-if="chargedDelivery.ctype == 'AT' && (chargedDelivery.dprice > 0 || cart.delivery_extra > 0)" class="desc_txt">+{{(chargedDelivery.dprice + cart.delivery_extra) | format()}} surcharge</span>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="mobileunitcost"></div>
                  <div class="mobileunithkdvalue"> {{curr}} {{cart.delivery_cost |format(fmt)}}
                  </div>
                </div>
              </div>
            </div>
            <div class="mobcharge" v-if="cart.payment_id != null && cart.payment_cost != 0">
              <div class="mobdiscount1">
                <div class="pull-left">
                  <div class="mobileunitcost1">
                    <span v-if="common_res['item_'+chargedPayment.id] != null">{{common_res['item_'+chargedPayment.id]}}</span>
                    <span v-else>{{chargedPayment.name}}</span>
                    <br>
                    <span v-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'PT' && common_res['item_charge_'+chargedPayment.id] != null" class="desc_txt">+{{((chargedPayment.dprice + cart.payment_extra) * 100) | format('#.0', common_res['item_charge_'+chargedPayment.id])}}</span>
                    <span v-else-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'PT'" class="desc_txt">+{{(chargedPayment.dprice * 100) | format()}}% surcharge</span>
                    <span v-else-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'AT' && common_res['item_charge_'+chargedPayment.id] != null" class="desc_txt">+{{(chargedPayment.dprice + cart.payment_extra) | format('#.0', common_res['item_charge_'+chargedPayment.id])}}</span>
                    <span v-else-if="(chargedPayment.dprice > 0 || cart.payment_extra > 0) > 0 && chargedPayment.ctype == 'AT'" class="desc_txt">+{{(chargedPayment.dprice) | format()}} surcharge</span>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="mobileunitcost"></div>
                  <div class="mobileunithkdvalue"> {{curr}} {{cart.payment_cost |format(fmt)}} </div>
                </div>
              </div>
            </div>
            <div class="mobcharge" v-for="(ex) in cart.extras==null?[]:(cart.extras.filter(ex => ex.dprice != 0 && (ex.itype == 'OC' || ex.itype == 'SC')))" v-bind:key="ex.id">
              <div class="mobdiscount1">
                <div class="pull-left">
                  <div class="mobileunitcost1">
                    <span v-if="common_res['item_'+ex.id] != null">{{common_res['item_'+ex.id]}}</span>
                    <span v-else>{{getItemName(ex, cart.extralist)}}</span>
                    <br>
                    <span v-if="ex.ctype.indexOf(':') > 0 && ex.odprice > 0 && common_res['item_charge_'+ex.id] != null" class="desc_txt">{{getSurcharge(ex, cart.extralist, common_res['item_charge_'+ex.id])}}</span>
                    <span v-else-if="ex.ctype.indexOf(':') > 0 && ex.odprice > 0" class="desc_txt">{{getSurcharge(ex, cart.extralist)}} surcharge</span>
                    <span v-else class="desc_txt"></span>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="mobileunitcost"></div>
                  <div v-if="ex.dprice >= 0" class="mobileunithkdvalue"> {{curr}} {{ex.dprice |format()}} </div>
                  <div v-else class="mobileunithkdvalue"> {{curr}} ({{(ex.dprice * -1) |format()}}) </div>
                </div>
              </div>
            </div>
            <div class="totalcalvalue">
              <div class="pull-left"><img src="@/images/valueicon.png" alt="image"></div>
              <div class="pull-right">
                <div class="totalcal"> <span> Total </span> <span class="valuehkd"> {{curr}} </span> 
                  <span class="valueno"> {{ftotal | format(fmt)}} </span>
                  <!--span v-if="ototal != null" class="valueno"> {{ototal | format()}} </span>
                  <span v-else class="valueno"> {{totala | format()}} </span-->
                </div>
              </div>
            </div>
          </div>
          <div class="protext">
            <p v-if="minAmt > 0"> * <span>{{res.firstorder | printLine({'curr':curr, 'firstamt':formatPrice(companyinfo.firstamount), 'day':getDays(companyinfo.hoursleft), 'hour':getHours(companyinfo.hoursleft)})}}</span> <span v-if="companyinfo.hoursleft > 0">{{res.firstorder_time | printLine({'curr':curr, 'firstamt':formatPrice(companyinfo.firstamount), 'day':getDays(companyinfo.hoursleft), 'hour':getHours(companyinfo.hoursleft)})}}</span></p>
            <!--
            <p v-if="drange.amount != -1"> * {{res.freeshipping | printLine({'shipping':res.sfexpress, 'curr':curr, 'drange':formatPrice(drange.amount), 'displayname':drange.displayname})}}</p>
            -->
          </div>
        </div>
        <!----------> 
      </div>
    </div>
    <!---------->
    <div class="shopBlock cards" v-if="cart != null && cart.productlist != null && cart.productlist.length > 0">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings"> <span><img src="@/images/advanced.png" alt="#"></span>{{res.payterms}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12" v-for="(payment) in cart.paymentlist" v-bind:key="payment">
          <div class="boxOuter" :style="payment_id == payment.id?'border-color:red':''">
            <a href="javascript:void(0)" v-on:click="setPayment(payment)">
              <div class="box">
                <div class="boximg"><img :src="pageRoot+'/images/payment/'+payment.seq +'.png'" alt=""></div>
                <div class="boxinfo" :payment_id="payment.id">
                  <h4 v-if="common_res['item_'+payment.id] != null" v-html="common_res['item_'+payment.id]"></h4>
                  <h4 v-else> {{payment.name}}</h4>
                  <span v-if="payment.dprice > 0 && payment.ctype == 'PT' && common_res['item_charge_'+payment.id] != null">(+{{payment.dprice * 100 | format('#.0', common_res['item_charge_'+payment.id])}})</span>
                  <span v-else-if="payment.dprice > 0 && payment.ctype == 'PT'">(+{{payment.dprice * 100 | format('#.0')}}% surcharge)</span>
                  <span v-else-if="payment.dprice > 0 && payment.ctype == 'AT' && common_res['item_charge_'+payment.id] != null">(+{{payment.dprice | format('#.0', common_res['item_charge_'+payment.id])}})</span>
                  <span v-else-if="payment.dprice > 0 && payment.ctype == 'AT'">(+{{payment.dprice | format('#.0')}} surcharge)</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12" v-for="(payment) in cart.out_paymentlist" v-bind:key="payment" v-if="payment.range != null && payment.range.length > 1 && payment.range[payment.range.length-1] > 0">
          <div class="boxOuter off" :style="payment_id == payment.id?'border-color:red':''">
            <a href="javascript:void(0)">
              <div class="box">
                <div class="boximg">
                  <!--img :src="pageRoot+'/images/delivery/'+delivery.seq+'.png'" alt=""-->
                  <imageIcon :src="pageRoot+'/images/payment/'+payment.seq+'.png'" :noimg="pageRoot+'/images/payment/payment.png'" alt=""/>
                  </div>
                <!--div class="boxinfo" v-if="common_res['item_'+payment.id] != null">{{common_res['item_'+payment.id] == null?payment.name:common_res['item_'+payment_id]}}<br-->
                <div class="boxinfo" :payment_id="payment.id">
                  <h4 v-if="common_res['item_'+payment.id] != null" v-html="common_res['item_'+payment.id]"></h4>
                  <h4 v-else> {{payment.name}}</h4>
                  <span v-if="payment.dprice > 0 && payment.ctype == 'PT' && common_res['item_charge_'+payment.id] != null">(+{{payment.dprice * 100 | format('#.0', common_res['item_charge_'+payment.id])}})</span>
                  <span v-else-if="payment.dprice > 0 && payment.ctype == 'PT'">(+{{payment.dprice * 100 | format('#.0')}}% surcharge)</span>
                  <span v-else-if="payment.dprice > 0 && payment.ctype == 'AT' && common_res['item_charge_'+payment.id] != null">(+{{payment.dprice | format('#.0', common_res['item_charge_'+payment.id])}})</span>
                  <span v-else-if="payment.dprice > 0 && payment.ctype == 'AT'">(+{{payment.dprice | format('#.0')}} surcharge)</span>
                  <br><span v-if="payment.range != null && payment.range.length > 1">({{common_res['item_available'].replace('${curr}', curr).replace('${min}', formatPrice(payment.range[payment.range.length-1]))}})</span>
                </div>
                <!--
                <div :r="payment.range" class="boxinfo" v-else>{{payment.name}}<br>
                  <span v-if="payment.range != null && payment.range.length > 1">({{common_res['item_available'].replace('${curr}', curr).replace('${min}', formatPrice(payment.range[payment.range.length-1]))}})</span>
                </div>
                -->
              </div>
            </a>
          </div>
        </div>
        <!--div class="col-md-6 col-sm-12 col-xs-12">
          <div class="boxOuter"> <a href="javascript:void(0)">
            <div class="box">
              <div class="boximg"><img src="@/images/cc.png" alt=""></div>
              <div class="boxinfo">
                <h4> Credit card </h4>
                <span>(+3.5% surcharge)</span></div>
            </div>
            </a> </div>
        </div-->
      </div>
    </div>
    <div class="shopBlock" v-if="cart != null && cart.productlist != null && cart.productlist.length > 0 && country_payinfo != null">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings"> <span><img src="@/images/advanced.png" alt="#"></span>{{res.payinst}}</div>
        </div>
      </div>
      <div class="row">
        <div v-if="common_res.payment['instructions_id_'+payment_id]" class="col-xs-12 shopbtm" v-html="common_res.payment['instructions_id_'+payment_id]">
        </div>
        <div v-else-if="common_res.payment.instructions" class="col-xs-12 shopbtm" v-html="common_res.payment.instructions">
        </div>
        <div v-else class="col-xs-12 shopbtm">
          <p> <span class="largetext">{{res.bank}} :</span> {{country_payinfo.bank}}</p>
          <p> <span class="largetext">{{res.bankacc}} :</span> {{country_payinfo.bankacc}}</p>
          <p> <span class="largetext">{{res.accname}} :</span> <a href="mailto:info@sampsonstore.com">{{country_payinfo.accname}}</a></p>
          <p v-if="country_payinfo.swiftcode"> <span class="largetext">{{res.swiftcode}} :</span> {{country_payinfo.swiftcode}}</p>
        </div>
      </div>
    </div>
    <div class="shopBlock payment" v-if="cart != null && cart.productlist != null && cart.productlist.length > 0">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings option-chkbox">
            <span><img src="@/images/truck.png" alt="#"></span>
            <div class="formHeadings-title">
              {{res.deliveryopt}}
              <span>*{{res.plssel}}</span>
            </div>
            <!--span v-if="cart.extralist[cart.extralist.length-1].id==1008" style="float:right">
              <input v-on:click="setExtraID(cart.extralist[cart.extralist.length-1])" type="checkbox" :value="cart.extralist[cart.extralist.length-1].id" name="extra_id" id="express">
              &nbsp;
              <label for="express">{{cart.extralist[cart.extralist.length-1].name}}</label>
            </span-->
            <!--
            <span v-for="(eitem) in Array.of(getItem({'id':expressID}, cart.extralist))" style="float:right" v-bind:key="eitem.id">
              <input v-on:click="setExtraID(eitem)" type="checkbox" :value="eitem.id" name="extra_id" id="express" :checked="getItem({'id':eitem.id}, cart.extras).dprice != 0">
              &nbsp;
              <label for="express">{{eitem.name}}</label>
            </span>
            -->
            <div class="chkbox express" v-for="(eitem) in Array.of(getItem({'id':expressItem.id}, cart.extralist)).filter(eitem=>eitem.id!=null)" style="float:right" v-bind:key="eitem.id">
              <label class="chkbox-label">
                <img class="chkbox-icon" src="@/images/icon-express.png">{{getItemResName(eitem)}}<input v-on:click="setExtraID($event, eitem, expressItem)" type="checkbox" :value="eitem.id" name="extra_id" id="express" :checked="getItem({'id':eitem.id}, cart.extras).dprice != 0">
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12" v-for="(delivery) in cart.deliverylist" v-bind:key="delivery">
          <div class="boxOuter" :style="delivery_id == delivery.id?'border-color:red':''">
            <a href="javascript:void(0)" v-on:click="setDelivery(delivery)">
              <div class="box">
                <div class="boximg">
                  <!--img :src="pageRoot+'/images/delivery/'+delivery.seq+'.png'" alt=""-->
                  <imageIcon :src="pageRoot+'/images/delivery/'+delivery.seq+'.png'" :noimg="pageRoot+'/images/delivery/default.png'" alt=""/>
                  </div>
                <div class="boxinfo" :delivery_id="delivery.id">
                  <h4 v-if="common_res['item_'+delivery.id] != null" v-html="common_res['item_'+delivery.id]"></h4>
                  <h4 class="boxinfo" v-else>{{delivery.name}}</h4>
                </div>
                <br>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12" v-for="(delivery) in cart.out_deliverylist" v-bind:key="delivery" v-if="delivery.range != null && delivery.range.length > 1 && delivery.range[delivery.range.length-1] > 0">
          <div class="boxOuter off" :style="delivery_id == delivery.id?'border-color:red':''">
            <a href="javascript:void(0)">
              <div class="box">
                <div class="boximg">
                  <!--img :src="pageRoot+'/images/delivery/'+delivery.seq+'.png'" alt=""-->
                  <imageIcon :src="pageRoot+'/images/delivery/'+delivery.seq+'.png'" :noimg="pageRoot+'/images/delivery/default.png'" alt=""/>
                </div>
                <div class="boxinfo" :delivery_id="delivery.id">
                  <h4 v-if="common_res['item_'+delivery.id] != null" v-html="common_res['item_'+delivery.id]"></h4>
                  <h4 v-else> {{delivery.name}}</h4>
                  <br><span v-if="delivery.range != null && delivery.range.length > 1">({{common_res['item_available'].replace('${curr}', curr).replace('${min}', formatPrice(delivery.range[delivery.range.length-1]))}})</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div style="clear:both" class="row" v-if="cart != null && cart.productlist != null && cart.productlist.length > 0">
      <div class="col-md-12 col-sm-12 text-center" v-if="!processing">
        <!--div class="centerbutton"-->
          <input class="form-control submitButton" :value="(cartmode==0)?res.confirm:res.saveamend" type="submit" v-on:click="confirmOrder($event)">
          <input v-if="cartmode == 1" class="form-control submitButton" :value="res.cancelamend" type="submit" v-on:click="cancelAmend($event)">
        <!--/div-->
      </div>
    </div>
    <div class="row" v-else-if="cartmode == 1">
      <div class="col-md-12 col-sm-12 text-center">
        <input class="form-control submitButton" :value="res.cancelamend" type="submit" v-on:click="cancelAmend($event)">
      </div>
    </div>
  </div>
</section>
</template>

<script>

import utils from './Utils.vue'
import cartProduct from './CartProduct.vue'
import billInfo from './BillInfo.vue'
import mCartProduct from './MCartProduct.vue'
import imageIcon from './ImageIcon.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'cart',
  props:['name', 'countries', 'common_res', 'res', 'discountlist', 'companyinfo', 'currencies', 'deliverylist'],
  data () {
    return {
      infoShown:null,
      expressItem:null,
      waiting_threshold:10,
      bill:null,
      fmt:null,
      locale:null,
      curr:null,
      processing:false,
      cartmode:0,
      shippinginfo:null,
      shippingid:"-1",
      toshowaddrs:false,
      delivery_id:null,
      payment_id:null,
      products:[],
      disinfo:[],
      token:null,
      submitted:false,
      totala:0,
      cart:null,
      subtotal:[],
      extra_ids:[],
      error:{}
    }
  },
  computed: {
    country_payinfo:function() {
      var country_id = this.companyinfo.country_id;
      var c = this.common_res.payment['country_id_'+country_id];
      if (c != null) return c;
      return this.common_res.payment['country_id'];
    },
    minAmt:function() {
      var remain = this.companyinfo.firstamount;
      if (this.companyinfo.rate != null && this.companyinfo.rate != '') {
        remain = remain * this.companyinfo.rate;
      }
      //console.log('minAmt', this.companyinfo.currency, this.companyinfo.rate, this.companyinfo.firstamount, remain);
      if (this.companyinfo.totalamt == null) {
        //return this.companyinfo.firstamount;
        return remain
      }
      for (var i=0;i<this.companyinfo.totalamt.length;i++) {
        remain = remain - this.companyinfo.totalamt[i].total;
      }
      if (this.companyinfo.hoursleft > 0 && remain > 0) {
        return remain
      }
      return remain;
    },
    chargedDelivery :function() {
      if (this.cart.delivery_id == null) return null;
      if (this.cart.deliverylist == null) return null;
      for (var i=0;i<this.deliverylist.length;i++) {
        if (this.deliverylist[i].itemid == this.cart.delivery_id) {
          var newd = JSON.parse(JSON.stringify(this.deliverylist[i]));
          newd.id = newd.itemid;
          try {
            newd.conditions = JSON.parse(newd.conditions);
          } catch(e) {
            newd.conditions = {}
          }
          newd.dprice = parseFloat(newd.dprice);
          console.log(newd);
          return newd;
        }
      }
      //for (var i=0;i<this.cart.deliverylist.length;i++) {
      //  if (this.cart.deliverylist[i].id == this.cart.delivery_id) {
      //    return this.cart.deliverylist[i];
      //  }
      //}
      return null;
    },
    chargedPayment:function() {
      if (this.cart.payment_id == null) return null;
      if (this.cart.paymentlist == null) return null;
      for (var i=0;i<this.cart.paymentlist.length;i++) {
        if (this.cart.paymentlist[i].id == this.cart.payment_id) {
          return this.cart.paymentlist[i];
        }
      }
      return null;
    },
    ftotal:function() {
      var tt = 0;
      if (this.ototal != null) {
        tt = this.ototal;
      } else {
        tt = this.totala;
      }
      if (this.cart != null) {
        if (this.cart.payment_id != null) {
          tt = tt + this.cart.payment_cost;
        }
        if (this.cart.delivery_id != null) {
          tt = tt + this.cart.delivery_cost;
        }
        if (this.cart.extras != null) {
          for (var i=0;i<this.cart.extras.length;i++) {
            tt = tt + this.cart.extras[i].dprice;
          }
        }
      }
      return tt;
    },
    invoiceNo:function() {
      //var id = localStorage.getItem('sampsonstore.b2b.cart.invoiceid');
      var id = utils.getStorageStr('cart.invoiceid');
      if (id != null) {
        this.cartmode = 1;
        return id;
      }
      this.cartmode = 0;
      if (this.companyinfo.code) {
        return this.companyinfo.code;
      }
      var inv = this.companyinfo.custcode;
      var curyear = new Date().getFullYear()+'';
      var count = 0;
      if (this.companyinfo.totalamt != null) {
        for (var i=0;i<this.companyinfo.totalamt.length;i++) {
          if (this.companyinfo.totalamt[i].year == curyear) {
            count = parseInt(this.companyinfo.totalamt[i].count);
          }
        }
      }
      return inv+curyear+'V'+(Vue.filter('format')((count+1), '000'));
    },
    curdate:function() {
      var date = new Date();
      return date;
      //return date.getDate() + " " + this.common_res.month['m'+(date.getMonth()+1)] + ", " + date.getFullYear();
    },
    drange:function() {
      var promdel = {"amount":-1};
      if (this.cart != null && this.cart.out_deliverylist != null) {
        for (var i=0;i<this.cart.out_deliverylist.length;i++) {
          var d = this.cart.out_deliverylist[i];
          if (d.range != null && d.range.length == 2) {
            if (d.range[1] > 0 && d.range[1] > this.cart.ototal) {
              promdel["amount"] = d.range[1] - this.cart.ototal;
              for (var j=0;j<this.deliverylist.length;j++) {
                if (d.id == this.deliverylist[j].itemid) {
                  promdel["displayname"] = this.deliverylist[j].displayname;
                  break;
                }
              }
              break;
            }
          }
        }
      }
      return promdel;
    },
    pageRoot:function() {
      return utils.getPageRoot();
    }
  },
  components: {
    cartProduct,
    billInfo,
    imageIcon,
    mCartProduct
  },
  created: function() {
    this.init();
  },
  methods: {
    getProductStock:function(product) {
      if (product.stock >= 0) {
        return parseInt(product.stock) + parseInt(utils.getAQty(product.pdetails.product_id));
      } else {
        return parseInt(utils.getAQty(product.pdetails.product_id));
      }
    },
    formatPrice(price) {
      return Vue.filter('format')(price);
    },
    getDays(hours) {
      return parseInt(hours / 24);
    },
    getHours(hours) {
      return parseInt(hours % 24);
    },
    getItem(item, list) {
      if (list == null) return {};
      for (var i=0;i<list.length;i++) {
        if (list[i].id == item.id) {
          return list[i];
        }
      }
      return {};
    },
    getSurcharge(item, list, txt) {
      for (var i=0;i<list.length;i++) {
        if (list[i].id == item.id && list[i].ctype.indexOf(':') > 0) {
          //console.log(item, list[i]);
          var ctype_val = parseFloat(list[i].ctype.substring(list[i].ctype.indexOf(':')+1));
          if (ctype_val != parseFloat(item.dprice)) {
            ctype_val = Vue.filter('format')(list[i].dprice * 100, '#.0', txt) + (txt==null?'%':'');
          } else if (txt != null) {
            return '+'+Vue.filter('format')(ctype_val, '#.0', txt).replace('%', '');
          }
          return '+'+ctype_val;
        }
      }
      return "+0";
    },
    getItemName(item, list) {
      if (list == null) return null;
      for (var i=0;i<list.length;i++) {
        if (list[i].id == item.id) {
          return list[i].name;
        }
      }
      return null;
    },
    cancelAmend(evt) {
      utils.restoreCart();
      window.location.reload();
    },
    confirmOrder(evt) {
      var self = this;
      if (self.processing) return;
      var cc = utils.getCartStorage();
      if (cc.length == 0) {
        return;
      }
      self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
      self.processing = true;
      var formdata = new FormData();
      var url = 'upd.is?locale='+this.locale;
      for (var i=0;i<this.cart.productlist.length;i++) {
        //url = url + '&product_id='+this.cart.productlist[i].product_id;
        formdata.append('product_id', this.cart.productlist[i].product_id);
      }

      var aqty = utils.getStorageStr('cart.aqty');
      if (aqty != null) {
        for (var i=0;i<cc.length;i++) {
          var a = utils.getAQty(cc[i].product_id);
          if (a > 0) {
            cc[i].cqty = a;
          }
        }
      }
      formdata.append('cart', JSON.stringify(cc));
      Vue.http.post(utils.getServerPath()+'/cart/'+url, formdata).then(response => {
        //console.log(self.cart, response.body.cart.productlist);
        if (response.body.cart != null) {
          // assign the new calculated cart @20210308
          self.cart = response.body.cart;
          //self.readCart(false);
        }
        if (self.companyinfo.code != response.body.companyinfo.code) {
          self.companyinfo.code = response.body.companyinfo.code;
          self.invoiceNo = response.body.companyinfo.code;
          console.log('changed', self.invoiceNo);
        }
        if (response.body.productlist != null && response.body.productlist.length > 0) {
          var products = response.body.productlist;
          for (var j=0;j<self.cart.productlist.length;j++) {
            for (var i=0;i<products.length;i++) {
              if (self.cart.productlist[j].product_id == products[i].pdetails.product_id) {
                var aqty = utils.getAQty(products[i].pdetails.product_id);
                //console.log(self.cart.productlist[j].nostock);
                if (aqty + products[i].stock < 0) {
                  self.cart.productlist[j].nostock = true;
console.log('No stock detected before confirm', self.cart.productlist[j], products[i].stock, aqty);
                } else if (self.cart.productlist[j].nostock) {
                  self.$root.$emit('nostock.'+self.cart.productlist[i].product_id, true);
                  //self.cart.productlist[j].nostock = false;
                } else {
                  self.$root.$emit('nostock.'+self.cart.productlist[i].product_id, false);
                  self.cart.productlist[j].nostock = false;
                }
                self.cart.productlist[j].stock = products[i].stock;
                break;
              }
            }
          }
        }
        if (self.cart.productlist.length > 0) {
          self.goConfirmOrder(evt);
        } else {
          self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
        }
      });
    },
    goConfirmOrder(evt) {
      if (this.ftotal < this.minAmt) {
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':Vue.filter('printLine')(this.res.minamt, {'curr':this.currencies[0].desp, 'amt':this.formatPrice(this.companyinfo.firstamount)}), 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        this.processing = false;
        return;
      }

      var self = this;
      if (this.payment_id == null) {
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.payment_msg, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        this.processing = false;
        return;
      }

      if (this.delivery_id == null) {
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.delivery_msg, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        this.processing = false;
        return;
      }
      var formdata = new FormData();
      var invoice = [];
      invoice.push(this.invoiceNo);
      invoice.push(this.companyinfo.custid);
      if (this.shippingid != "-1") {
        invoice.push(this.shippingid);
      } else {
        invoice.push(this.companyinfo.bchid);
      }
      invoice.push(this.companyinfo.name);
      invoice.push(this.companyinfo.poc);
      invoice.push(this.companyinfo.address1);
      invoice.push(this.companyinfo.address2);
      invoice.push(this.companyinfo.address3);
      invoice.push(this.companyinfo.address4);
      invoice.push(this.companyinfo.email);
      invoice.push(this.companyinfo.tel);
      invoice.push(this.shippinginfo.name);
      invoice.push(this.shippinginfo.poc);
      invoice.push(this.shippinginfo.address1);
      invoice.push(this.shippinginfo.address2);
      invoice.push(this.shippinginfo.address3);
      invoice.push(this.shippinginfo.address4);
      invoice.push(this.shippinginfo.deliveryremark);
      if (this.shippinginfo.email == null || this.shippinginfo.email == '') {
        invoice.push(this.companyinfo.email);
      } else {
        invoice.push(this.shippinginfo.email);
      }
      invoice.push(this.shippinginfo.tel);
      invoice.push(this.cart.payment_id);
      invoice.push(this.cart.delivery_id);
      invoice.push(this.getName(this.cart.delivery_id, this.cart.deliverylist));
      invoice.push(this.getName(this.cart.payment_id, this.cart.paymentlist));
      for (var i=0;i<this.cart.productlist.length;i++) {
        if (this.cart.productlist[i].nostock) {
          this.$root.$emit('nostock.'+this.cart.productlist[i].product_id, true);
          this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.adjusted, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
          this.processing = false;
          return;
        } else if (this.cartmode == 1) {
          //this.$root.$emit('qty', {id:this.cart.productlist[i].product_id, idx:(this.cart.productlist.length - i - 1), oqty:this.cart.productlist[i].oqty});
        }
      }
      var d = [];
      for (var i=0;i<self.disinfo.length;i++) {
        var id = self.disinfo[i];
        for (var j=0;j<self.discountlist.length;j++) {
          if (self.discountlist[j].id == id) {
            d.push(self.discountlist[j]);
            break;
          }
        }
      }
      invoice.push(JSON.stringify(d));
      formdata.append('invoice', JSON.stringify(invoice));
      var aqty = utils.getStorageStr('cart.aqty');
      if (aqty != null) {
        formdata.append('aqty', aqty);
      }
      //var invcode = localStorage.getItem('sampsonstore.b2b.cart.invoiceid');
      var invcode = utils.getStorageStr('cart.invoiceid');
      var curl = 'confirm.is?locale=' + self.locale;
      //alert(curl);
      //return;
      if (invcode != null) {
        curl = curl + '?invcode='+invcode;
        formdata.append('invcode', invcode);
      }
/*
      Vue.http.post(utils.getServerPath()+'/cart/'+'confirm.is', formdata).then(response => {
        var res = response.body;
        console.log('confirm', res);
        if (res.invid != null) {
          utils.setCartStorage([]);
          window.location.reload();
        }
      });
*/
      var buttons = [
        {
          "value":this.common_res.message.yes,
          "func":function() {
            self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
            Vue.http.post(utils.getServerPath()+'/cart/'+curl, formdata).then(response => {
              var res = response.body;
              if (res.cart == '-1') {
                setTimeout(function() {
                  window.location.reload();
                }, 1000);
              } else if (res.invcode != null) {
                utils.setCartStorage([]);
                utils.restoreCart();
                var gourl = 'done.html?invcode='+res.invcode;
                if (res.payment_url != null) {
                  gourl = res.payment_url;
                }
                setTimeout(function() {
                  //window.location = 'done.html?invcode='+res.invcode;
                  window.location = gourl;
                }, 500);
              } else if (res.invid != null) {
                self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.done, 'button':self.common_res.message.close, 'icon':'fa-check'});
                utils.setCartStorage([]);
                utils.restoreCart();
                setTimeout(function() {
                  window.location.reload();
                }, 1000);
              }
              self.cartmode = 0;
            }, response => {
              alert("error ("+response.status+") occurred, please try again after reloaded.");
              window.location.reload();
              console.log(response);
            });
          }
        },
        {
          "value":this.common_res.message.no,
          "func":function() {
            self.processing = false;
            self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
          },
          "timeout":true
        }
      ];
      this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.res.confirm_msg, 'icon':'fa-question', 'buttons':buttons, 'timeout':5000});

    },
    getName(id, list) {
      if (list != null) {
        for (var i=0;i<list.lenght;i++) {
          if (list[i].id == id) return list[i].name;
        }
      }
      return null;
    },
    setPayment(payment) {
      var self = this;
      if (this.payment_id == payment.id) this.payment_id = null;
      else this.payment_id = payment.id;
      if (self.cart.productlist.length > self.waiting_threshold) {
        self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
      }
      if (this.payment_id == null) {
        Vue.http.delete(utils.getServerPath()+'/cart/'+'upd.is?'+(new Date().getTime())+'&payment_id='+payment.id).then(response => {
          self.cart = response.body.cart;
          self.readCart(false);
          if (self.cart.productlist.length > self.waiting_threshold) {
            setTimeout(function() {
              self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            }, 50);
          }
        });
      } else {
        Vue.http.get(utils.getServerPath()+'/cart/'+'upd.is?'+(new Date().getTime())+'&payment_id='+payment.id+'&addr_extra_info='+encodeURIComponent(self.getExtraInfo(self.shippingid))).then(response => {
          self.cart = response.body.cart;
          self.readCart(false);
          if (self.cart.productlist.length > self.waiting_threshold) {
            setTimeout(function() {
              self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            }, 50);
          }
        });
      }
    },
    async setExtraID(evt, extra, itemText) {
      var self = this;
      var todaystr = '';
      if (itemText['popup'] == 'always') {
        self.infoShown[extra.id] = null;
      } else if (itemText['popup'] == 'today') {
        var today = new Date();
        todaystr = ':'+today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      } else if (itemText['popup'] == 'hour') {
        var today = new Date();
        todaystr = ':'+today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()+'-'+today.getHours();
      }
      if (this.infoShown[extra.id] ==  null || this.infoShown[extra.id] != self.invoiceNo+":"+extra.dprice+':'+extra.ctype+todaystr) {
        if (evt.target.checked) {
          //console.log(extra, itemText);
          var isexpress = await new Promise((resolve, reject) => {
            self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':itemText.description.replace('${dprice}', parseInt(extra.dprice*100)).replace('${min}', extra.ctype.substring(4)).replace('${max}', extra.ctype.substring(4)), 'buttons':[
              {
                "value":self.common_res.message.yes,
                "func":function() {
                  self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                  self.infoShown[extra.id] = self.invoiceNo+":"+extra.dprice+":"+extra.ctype+todaystr;
                  utils.saveStorage('info_shown', self.infoShown);
                  resolve(true);
                }
              },
              {
                "value":this.common_res.message.no,
                "func":function() {
                  resolve(false);
                  self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                },
                "timeout":true
              }
            ], 'icon':'fa-exclamation'});
          });
          if (!isexpress) {
            evt.target.checked = false;
            return;
          }
        }
      }
      var self = this;
      if (self.cart.productlist.length > self.waiting_threshold) {
        self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
      }
      for (var i=0;i<self.extra_ids.length;i++) {
        if (self.extra_ids[i] == extra.id) {
          Vue.http.delete(utils.getServerPath()+'/cart/'+'upd.is?'+(new Date().getTime())+'&extra_id='+extra.id).then(response => {
            self.cart = response.body.cart;
            self.extra_ids.splice(i, 1);
            self.readCart(false);
            if (self.cart.productlist.length > self.waiting_threshold) {
              setTimeout(function() {
                self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
              }, 50);
            }
          });
          return;
        }
      }
      Vue.http.get(utils.getServerPath()+'/cart/'+'upd.is?'+(new Date().getTime())+'&extra_id='+extra.id).then(response => {
        self.cart = response.body.cart;
        self.extra_ids.push(extra.id);
        self.readCart(false);
        if (self.cart.productlist.length > self.waiting_threshold) {
          setTimeout(function() {
            self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
          }, 50);
        }
      });
    },
    setExtraInfo(extra_info) {
      var self = this;
      Vue.http.get(utils.getServerPath()+'/cart/'+'upd.is?'+(new Date().getTime())+'&addr_extra_info='+encodeURIComponent(extra_info)).then(response => {
        self.cart = response.body.cart;
        self.readCart(false);
      });
    },
    setDelivery(delivery) {
      var self = this;
      if (this.delivery_id == delivery.id) this.delivery_id = null;
      else this.delivery_id = delivery.id;
      if (self.cart.productlist.length > self.waiting_threshold) {
        self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
      }
      if (this.delivery_id == null) {
        Vue.http.delete(utils.getServerPath()+'/cart/'+'upd.is?'+(new Date().getTime())+'&delivery_id='+delivery.id).then(response => {
          self.cart = response.body.cart;
          self.readCart(false);
          if (self.cart.productlist.length > self.waiting_threshold) {
            setTimeout(function() {
              self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            }, 50);
          }
        });
      } else {
        Vue.http.get(utils.getServerPath()+'/cart/'+'upd.is?'+(new Date().getTime())+'&delivery_id='+delivery.id+'&addr_extra_info='+encodeURIComponent(self.getExtraInfo(self.shippingid))).then(response => {
          self.cart = response.body.cart;
          self.readCart(false);
          if (self.cart.productlist.length > self.waiting_threshold) {
            setTimeout(function() {
              self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            }, 50);
          }
        });
      }
    },
    setShippingInfo:function(sid, branches) {
      if (branches != null) {
        for (var i=0;i<branches.length;i++) {
          if (sid == branches[i].bchid) {
            this.shippinginfo = branches[i];
            break;
          }
        }
      }
    },
    init:function() {
      var self = this;
      self.infoShown = utils.getStorage('info_shown');
      if (self.infoShown == null) self.infoShown = {};
      self.curr = utils.getCurrencySym();
      self.expressItem = this.getItemByCode('express');
      if (self.companyinfo.currency != '') {
        self.curr = self.companyinfo.currency;
        self.fmt = parseInt(self.companyinfo.ratedp);
      }
      if (self.companyinfo.ratedp != '') {
        self.fmt = parseInt(self.companyinfo.ratedp);
      }

      var c_curr = utils.getStorageStr("currency");
      if (c_curr == null) c_curr = '';
      if (c_curr != self.companyinfo.currency) {
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.curr_changed, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        setTimeout(function() {
          self.$root.$emit('remove', {'all':true});
        }, 1000);
      }
      utils.saveStorageStr("currency", self.companyinfo.currency);

      var shipid = utils.getStorage('shippingid');
      if (shipid != null) {
        self.shippingid = shipid;
      }
      if (self.companyinfo.branch != null) {
        self.shippinginfo = self.companyinfo.branch;
      } else {
        self.shippinginfo = self.companyinfo;
      }
      if (self.shippinginfo.bchid != self.shippingid) {
        this.setShippingInfo(this.shippingid, this.companyinfo.branches);
        //if (self.companyinfo.branches != null) {
        //  for (var i=0;i<self.companyinfo.branches.length;i++) {
        //    if (self.shippingid == self.companyinfo.branches[i].bchid) {
        //      self.shippinginfo = self.companyinfo.branches[i];
        //      break;
        //    }
        //  }
        //}
        self.shippingid = self.shippinginfo.bchid;
      }

      this.locale = utils.getLocale();
      try {
        var cc = utils.getCartStorage();
        if (cc != null && cc.length > 0) {
        }
        if (cc != null) {
          if (cc.length > self.waiting_threshold) {
            self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
          }
          self.$root.$once('cart', data => {
            //if (data.action != 'inited') return;
            var url = 'search.is?locale='+self.locale;
            var qtys = {};
            var formdata = new FormData();
            for (var i=0;i<cc.length;i++) {
              //url = url + '&product_id='+cc[i].product_id;
              formdata.append('product_id', cc[i].product_id);
              qtys[cc[i].product_id] = cc[i].oqty;
            }

            //Vue.http.get(utils.getServerPath()+'/cart/'+url).then(response => {
            Vue.http.post(utils.getServerPath()+'/cart/'+url, formdata).then(response => {
              self.products = response.body.productlist;
              for (var i=0;i<self.products.length;i++) {
                self.products[i].oqty = qtys[self.products[i].pdetails.product_id];
                self.subtotal.push(0);
              }
              self.setPos();
              self.pagination = response.body.pagination;
              if (self.pagination) {
                self.pageno = parseInt(self.pagination.current_page / self.pagination.num);
              }
              if (self.cart != null && self.cart.ototal == 0 && self.products.length > 0) {
                self.$root.$emit('loadcart');
              } else if (self.cart != null && self.cart.ototal > 0) {
                self.readCart(true);
              }
              if (cc.length > self.waiting_threshold) {
                setTimeout(function() {
                  self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                }, 50);
              }
            }).catch(err => {
              console.log(err);
            });
          });
        }
      } catch (e) {}
    },
    setPos:function() {
      var self = this;
      var pos = 0;
      var deta = 0;
      for (var i=0;i<self.products.length;i++) {
        self.products[i].pos = pos + deta;
        pos++;
        if (self.products[i].wcaseqty > 0 && self.products[i].wcasedct > 0) {
          deta++;
        }
      }
    },
    setSubTotal:function(st) {
      if (st.qty) {
        if (st.idx >= this.products.length) {
          //return;
        }
        this.products[st.idx].qty = st.qty;
      }
      this.subtotal[st.idx] = st.subtotal;
      var totalamt = 0;
      try {
        for (var i=0;i<this.subtotal.length;i++) {
          totalamt = totalamt + this.subtotal[i];
        }
      } catch (e) {
      }
      this.totala = totalamt;
    },
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    dnProductsList() {
      var self = this;
      var list = '';
      for (var i=0;i<self.products.length;i++) {
        list = list + (self.products[i].qty+' x ' + self.products[i].pdetails.product_name + " {"+self.products[i].pdetails.product_id+"}");
        if (i < self.products.length -1) {
          list = list + '\n';
        }
      }
      console.log(list);
      utils.download("bulk.txt", list);
    },
    getExtraInfo(shippingid) {
      if (shippingid == '-1') {
        return this.companyinfo.extracharge;
      } else if (this.companyinfo.branches != null) {
        for (var i=0;i<this.companyinfo.branches.length;i++) {
          var b = this.companyinfo.branches[i];
          if (b.bchid == shippingid) {
            return b.extracharge;
          }
        }
      }
      return "";
    },
    getItemByCode(code) {
      for (var i=0;i<this.common_res['items']['item'].length;i++) {
        if (this.common_res['items']['item'][i]['code'] == code) {
          return this.common_res['items']['item'][i];
        }
      }
      return null;
    },
    getItemResName(item) {
      for (var i=0;i<this.common_res['items']['item'].length;i++) {
        if (this.common_res['items']['item'][i]['id'] == item.id) {
          return this.common_res['items']['item'][i]['name'];
        }
      }
      return item.name;
    },
    deleteAllProducts() {
      var self = this;
      var buttons = [
        {
          "value":this.common_res.message.yes,
          "func":function() {
            self.$root.$emit('remove', {'all':true});
            self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
          }
        },
        {
          "value":this.common_res.message.no
        }
      ];
      this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.res.confirm_delete, 'icon':'fa-question', 'buttons':buttons});
    },
    readCart(notify) {
      if (this.cart != null) {
        console.log(this.cart.out_paymentlist);
        console.log(this.cart.out_deliverylist);
        if (this.cart.out_deliverylist != null) {
          for (var i=0;i<this.cart.out_deliverylist.length;i++) {
            var p = this.cart.out_deliverylist[i];
            if (this.delivery_id == p.id) {
              this.delivery_id = null;
              break;
            }
          }
        }
        if (this.cart.out_paymentlist != null) {
          for (var i=0;i<this.cart.out_paymentlist.length;i++) {
            var p = this.cart.out_paymentlist[i];
            if (this.payment_id == p.id) {
              this.payment_id = null;
              break;
            }
          }
        }
        this.setShippingInfo(this.shippingid, this.companyinfo.branches);
        if (this.cart.extras != null) {
          for (var i=0;i<this.cart.extras.length;i++) {
            if (this.cart.extras[i].dprice != 0) {
              if (this.extra_ids.indexOf(this.cart.extras[i].id) < 0) {
                this.extra_ids.push(this.cart.extras[i].id);
              }
            }
          }
        }
        var cc = utils.getCartStorage();
        var adjusted = false;
        var newcc = [];
        this.disinfo = [];
        this.ototal = this.cart.ototal;
        //console.log('read cart', this.cart, cc, this.products);
        if (this.cart.productlist != null) {
          for (var k=this.cart.productlist.length-1;k>=0;k--) {
            var p = this.cart.productlist[k];
            var dprice = 0;
            var dl = p.discounts;
            if (dl != null) {
              for (var i=0;i<dl.length;i++) {
                var did = dl[i].id;
                if (this.disinfo.indexOf(did) < 0) {
                  this.disinfo.push(did);
                }
                dprice = dprice + dl[i].dprice;
                if (this.discountlist != null)  {
                  for (var j=0;j<this.discountlist.length;j++) {
                    var d = this.discountlist[j];
                    if (d.id == did) {
                      dl[i].name = d.name;
                      dl[i].ctype = d.ctype;
                      dl[i].calamt = d.dprice;
                    }
                  }
                }
                p.dprice = dprice;
              }
            }
            if (this.products != null && this.products.length > 0) {
              var found = false;
              for (var j=0;j<this.products.length;j++) {
                if (this.products[j].pdetails.product_id == p.product_id) {
                  this.products[j].discounts = p.discounts;
                    // if no trade discount, it may be null
                  if (p.dprice == null) p.dprice = 0;
                  this.products[j].dprice = p.dprice;
                  this.products[j].total = this.products[j].subtotal +  p.dprice;
                  this.products[j].unitprice = p.unitprice;
                  this.products[j].subtotal = p.subtotal + p.dprice;
                  //console.log('readCart', this.products[j]);
                  found = true;
                  if (this.cartmode == 1) {
                    p.nostock = false;
                  } else {
                    if (p.nostock) {
                      this.$root.$emit('nostock.'+p.product_id, true);
                      adjusted = true;
                    } else {
                      this.$root.$emit('nostock.'+p.product_id, false);
                    }
                  }
                  //this.products[j].stock = p.stock;
                  break;
                }
              }
              if (!found) {
                //adjusted = true;
                console.log('product not found', p, k, this.products);
                //this.$root.$emit('notfound', {id:p.product_id, idx:k});
              } else {
                for (var j=0;j<cc.length;j++) {
                  if (cc[j].product_id == p.product_id) {
                    newcc.push({"product_id":p.product_id, "oqty":p.oqty});
                    //newcc.push(cc[j]);
                    break;
                  }
                }
              }
              if (found && notify && this.products != null && this.products.length > 0) {
                this.$root.$emit('details.'+p.product_id, p);
              }
            } else {
              newcc.push({"product_id":p.product_id, "oqty":p.oqty});
            }
          }
        }
        if (this.cart.paymentlist) {
          this.cart.paymentlist.sort(function(a, b) {
            return a.seq - b.seq;
          });
        }
        if (this.cart.deliverylist) {
          this.cart.deliverylist.sort(function(a, b) {
            return a.seq - b.seq;
          });
        }

        //if (!(this.cart.payment_id) && this.cart.paymentlist != null && this.cart.paymentlist.length == 1) {
        //  this.cart.payment_id = this.cart.paymentlist[0].id;
        //}

        if (this.cart.delivery_id) {
          this.delivery_id = this.cart.delivery_id;
        }
        if (this.cart.payment_id) {
          this.payment_id = this.cart.payment_id;
        }
        utils.setCartStorage(newcc);
        if (adjusted) {
          this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.adjusted, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        }
        this.$forceUpdate();
      }
    }
  },
  mounted: function() {
    this.$root.$on('selectBranch', data => {
      this.shippingid = data.shippingid;
      if (this.shippingid == '-1') {
        this.shippinginfo = this.companyinfo;
      } else {
        this.setShippingInfo(this.shippingid, this.companyinfo.branches);
      }
      if (data.extra_info != null) {
        this.setExtraInfo(data.extra_info);
      }
    });
    
    this.$root.$on('cart', data => {
      if (data.cart != null) {
        this.cart = data.cart;
        this.readCart(true);
      }
    });
    this.$root.$on('remove', data => {
      if (data.all == true) {
        this.products = [];
        this.subtotal = [];
      } else {
        this.products.splice(data.idx, 1);
        this.subtotal.splice(data.idx, 1);
      }
      if (this.subtotal.length == 0) {
        this.totala = 0;
      }
      this.setPos();
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cart.vue